export default "__VITE_ASSET__Ct3xUua___"